/**
 * @author HungNS
 */
const moduleAxios = {
    namespaced: true,
    state: () => ({
        isLoading: false
    }),
    mutations: {
        changeLoadingStatus(state, status) {
            state.isLoading = status;
        }
    },
    actions: {
        changeLoadingStatus(context, status) {
            context.commit('changeLoadingStatus', status)
        }
    }
};

export default moduleAxios;
